import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-media-player',
  templateUrl: './media-player.component.html',
  styleUrls: ['./media-player.component.css']
})
export class MediaPlayerComponent implements OnInit {  
  IsSemiAnonymous: boolean;
  @Input() path: string;
  @Input() isVideoFile: boolean;
  @Output() playMedia: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
    
  }

  Close() {
    this.playMedia.emit(false);
  }

  CloseKeyboard(event){
    if(event.keyCode == 13 || event.keyCode == 32){
      this.Close();
    }
  }

}
